import CircularLoader from "./CircularLoader";

export default CircularLoader;



// WEBPACK FOOTER //
// ./src/shared/components/CircularLoader/index.js